import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { experience } from '../data/experience';
import { Reveal } from './Reveal';
const ease = [0.23, 1, 0.32, 1] as const;
export function ExperienceList() {
  const [openId, setOpenId] = useState<string | null>(experience[0].id);
  return <ol className="border-l border-navy/15" data-id="element-50" data-mp="1s66bbu9dwo34">
      {experience.map((role, i) => {
      const isOpen = openId === role.id;
      return <li key={role.id} className="relative" data-id="element-51" data-mp="1jbi809nddggy" data-mpi={i}>
            <span aria-hidden="true" className={`absolute -left-[4.5px] top-9 h-2 w-2 rounded-full transition-colors duration-150 ease-out ${isOpen ? 'bg-gold' : 'bg-navy/25'}`} data-id="element-52" data-mp="1j9ozeot74m6b" />
            <Reveal delay={Math.min(i * 0.04, 0.12)} data-id="element-53" data-mp="14er71vy1rwp8">
              <div className={`border-b border-navy/10 pl-8 transition-colors duration-150 ease-out lg:pl-12 ${isOpen ? 'bg-white' : ''}`} data-id="element-54" data-mp="14gc1zmo9xhnm">
                <button type="button" onClick={() => setOpenId(isOpen ? null : role.id)} aria-expanded={isOpen} aria-controls={`role-${role.id}`} className="group flex w-full items-start justify-between gap-6 py-8 text-left" data-id="element-55" data-mp="jcljmllcw2ti">
                  <span className="grid gap-2 lg:grid-cols-12 lg:items-baseline lg:gap-6" data-id="element-56" data-mp="xc3enip8wcbb">
                    <span className="lg:col-span-3" data-id="element-57" data-mp="12bzf57yqhlm4">
                      <span className="block text-[11px] uppercase tracking-overline text-steel" data-id="element-58" data-mp="129dabg389k7l">
                        {role.dates}
                      </span>
                      {role.duration && <span className="mt-1 block text-[11px] uppercase tracking-overline text-navy/35" data-id="element-59" data-mp="sf4kx19hu7dn">
                          {role.duration}
                        </span>}
                    </span>
                    <span className="lg:col-span-9" data-id="element-60" data-mp="1jlbj35u0f6bm">
                      <span className="block font-display text-2xl font-light leading-snug text-navy lg:text-[1.75rem]" data-id="element-61" data-mp="1jk0ifevv2eoq">
                        {role.company}
                      </span>
                      <span className="mt-1.5 block text-[13px] uppercase tracking-overline text-gold" data-id="element-62" data-mp="19te2tko59o61">
                        {role.title}
                      </span>
                      {(role.location || role.employment) && <span className="mt-2 block text-[13px] text-steel" data-id="element-63" data-mp="vv7h12wgzemq">
                          {[role.employment, role.location].filter(Boolean).join(' · ')}
                        </span>}
                    </span>
                  </span>
                  <PlusIcon aria-hidden="true" className={`mt-2 h-5 w-5 shrink-0 text-navy/40 transition-transform duration-200 ease-out group-hover:text-gold ${isOpen ? 'rotate-45 text-gold' : ''}`} data-id="element-64" data-mp="lyuldzhd6qpc" />
                </button>

                <AnimatePresence initial={false} data-id="element-65" data-mp="2stn4i9j001p4">
                  {isOpen && <motion.div id={`role-${role.id}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease
              }} className="overflow-hidden" data-id="element-66" data-mp="2sraera700n1i">
                      <div className="grid gap-8 pb-10 lg:grid-cols-12 lg:gap-6" data-id="element-67" data-mp="29v2i2us1xkht">
                        <div className="lg:col-span-4 lg:col-start-4" data-id="element-68" data-mp="2esaqi3neea5v">
                          <p className="font-display text-lg font-light leading-relaxed text-navy" data-id="element-69" data-mp="2jt8hn5qdyeji">
                            {role.summary}
                          </p>
                        </div>

                        <div className="lg:col-span-5" data-id="element-70" data-mp="3v7c8i31ofmkc">
                          {role.bullets && <ul className="space-y-4" data-id="element-71" data-mp="180pove097rg2">
                              {role.bullets.map(b => <li key={b} className="flex gap-3" data-id="element-72" data-mp="131wie5jdx0pe">
                                  <span aria-hidden="true" className="mt-[9px] h-px w-4 shrink-0 bg-gold" data-id="element-73" data-mp="1h0w0svgb0jd4" />
                                  <span className="text-[14px] leading-[1.7] text-steel" data-id="element-74" data-mp="1qxijbdl5qybz">{b}</span>
                                </li>)}
                            </ul>}

                          {role.subRoles && <div className="mt-8 border-t border-navy/10 pt-6" data-id="element-75" data-mp="1voqrk6ar4dnk">
                              <p className="text-[11px] uppercase tracking-overline text-steel" data-id="element-76" data-mp="29p1kdevmg2bd">
                                Roles held
                              </p>
                              <ul className="mt-5 space-y-6" data-id="element-77" data-mp="24rrww4rsm0q6">
                                {role.subRoles.map(sub => <li key={sub.title + sub.dates} data-id="element-78" data-mp="2tatlssak45li">
                                    <p className="font-display text-[17px] font-light text-navy" data-id="element-79" data-mp="2ta21weqbnwb2">
                                      {sub.title}
                                    </p>
                                    <p className="mt-1 text-[11px] uppercase tracking-overline text-gold" data-id="element-80" data-mp="2jb2qwpi33okw">
                                      {[sub.dates, sub.location].filter(Boolean).join(' · ')}
                                    </p>
                                    <p className="mt-2 text-[14px] leading-[1.7] text-steel" data-id="element-81" data-mp="1vn34u2vpwmcn">
                                      {sub.summary}
                                    </p>
                                  </li>)}
                              </ul>
                            </div>}
                        </div>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </Reveal>
          </li>;
    })}
    </ol>;
}